import { z } from "zod"
import {
  type Column,
  columnSchema,
  DEFAULT_COLUMNS,
  withNumber,
} from "./columns"
import { type Grouping, groupingSchema } from "./grouping"

export const PROGRAMMES = { limit: 1000 }

export const TABS = ["overview", "all", "active", "archived"] as const

const tabSchema = z.enum(TABS)

export type Tab = z.infer<typeof tabSchema>

const directionSchema = z.enum(["asc", "desc"])

export type Direction = z.infer<typeof directionSchema>

export const programmesSearchSchema = z.object({
  tab: tabSchema.optional().catch(undefined),
  search: z.string().optional().catch(undefined),
  manufacturer: z.array(z.string()).optional().catch(undefined),
  model: z.array(z.string()).optional().catch(undefined),
  updater: z.array(z.string()).optional().catch(undefined),
  group: groupingSchema.optional().catch(undefined),
  columns: z.array(columnSchema).optional().catch(undefined),
  sort: columnSchema.optional().catch(undefined),
  direction: directionSchema.optional().catch(undefined),
})

export type ProgrammesSearch = z.infer<typeof programmesSearchSchema>

export type ProgrammesDisplay = {
  group: Grouping | undefined
  columns: Column[]
  sort: Column
  direction: Direction
}

export function tabLabel(tab: Tab): string {
  switch (tab) {
    case "overview":
      return "Overview"
    case "all":
      return "All"
    case "active":
      return "Active"
    case "archived":
      return "Archived"
  }
}

export function displayOf(search: ProgrammesSearch): ProgrammesDisplay {
  return {
    group: search.group,
    columns: search.columns ? withNumber(search.columns) : DEFAULT_COLUMNS,
    sort: search.sort ?? "title",
    direction: search.direction ?? "asc",
  }
}
